import { type ServiceMethod } from '@/application/interfaces/service';

export type Params = {
  cartId: string;
};

export type ChangeShipmentModalityData = {
  cartId: string;
  shipmentId: string;
  modalityType: string;
  scheduleDelivery?: string;
  periodDelivery?: string;
};

type Body = {
  shipmentId: string;
  modalityType: string;
  scheduleDelivery?: string;
  periodDelivery?: string;
};

export type Response = {
  data: {
    cartId: string;
    shipmentId: string;
    modalityType: string;
  };
};

const changeShipmentModality: ServiceMethod<
  Response,
  ChangeShipmentModalityData
> = (httpClient) => async (data, options) => {
  const { cartId, shipmentId, modalityType, scheduleDelivery, periodDelivery } =
    data;

  const { body: response } = await httpClient.put<Response, Body, Params>(
    '/api/v3/carts/{cartId}/change-shipment-modality',
    {
      ...options,
      body: {
        shipmentId,
        modalityType,
        scheduleDelivery,
        periodDelivery,
      },
      params: { cartId },
    }
  );

  return response;
};

export default changeShipmentModality;
